import React, { useState, createContext, useEffect } from 'react';
import axios from "axios";
import { LocalServer } from './templates/WebIp';
import { Authentication } from './templates/authentication';
import { Dashboard } from './templates/dashboard';
import { apiRequest } from './utils/apiHelper';
export const AppContext = createContext();

function App() {
  var link = LocalServer();
  const [accessToken, setAccessToken] = useState();
  useEffect(() => {
    if (accessToken !== undefined) {
      getExpired();
      getAgents();
    }
  }, [accessToken]);
  const [page, setPage] = useState('home');
  const [user, setUser] = useState();
  const [getExpiredLoad, setGetExpiredLoad] = useState(false);
  const [expired, setExpired] = useState();
  const [agents, setAgents] = useState();
  const [getLoad, setGetLoad] = useState(false);
  const [allAccounts, setAllAccounts] = useState();
  const [getAccountLoad, setGetAccountLoad] = useState(false);
  const [packages, setPackages] = useState();
  const [recentRenew, setRecentRenew] = useState({});
  const [invoice, setInvoice] = useState();
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [enquiries, setEnquiries] = useState();
  const [leadStatues, setLeadStatues] = useState();
  useEffect(() => { if (!invoiceModal) { setInvoice(); } }, [invoiceModal]);
  const getAgents = () => {
    apiRequest({
      url: `${link}api/cs/get/all/agents/`,
      token: accessToken,
      setLoading: setGetLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setAgents(data);
      }
    });
  }
  const getPackages = () => {
    apiRequest({
      url: `${link}api/cs/get/packages/`,
      token: accessToken,
      setLoading: setGetLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setPackages(data);
      }
    });
  }
  const getRecentRenew = () => {
    apiRequest({
      url: `${link}api/cs/get/last/bills/`,
      token: accessToken,
      setLoading: setGetLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setRecentRenew(data);
      }
    });
  }
  const getExpired = () => {
    apiRequest({
      url: `${link}api/cs/get/expired/accounts/`,
      token: accessToken,
      setLoading: setGetExpiredLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setExpired(data.values);
        setUser(prev => ({ ...prev, counts: data.counts }));
      }
    });
  }
  const getEnquiries = () => {
    apiRequest({
      url: `${link}api/cs/get/leads/`,
      token: accessToken,
      setLoading: setGetLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setEnquiries(data);
      }
    });
  }
  const getLeadStatuses = () => {
    apiRequest({
      url: `${link}api/cs/get/lead/statuses/`,
      token: accessToken,
      setLoading: setGetLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setLeadStatues(data);
      }
    });
  }
  const [staff, setStaff] = useState();
  const [getStaffLoad, setGetStaffLoad] = useState(false);
  const getStaffs = () => {
    apiRequest({
      url: `${link}api/cs/get/staffs/`,
      token: accessToken,
      setLoading: setGetStaffLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setStaff(data);
      }
    });
  }
  const [getQuickLinksLoad, setGetQuickLinksLoad] = useState(false);
  const [quickLinks, setQuickLinks] = useState();
  const getQuickLinks = () => {
    apiRequest({
      url: `${link}api/cs/get/quick/link/`,
      token: accessToken,
      setLoading: setGetQuickLinksLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setQuickLinks(data);
      }
    });
  }
  const [quickReport, setQuickReport] = useState();
  const [getQuickLoad, setGetQuickLoad] = useState(false);
  const getQuickReport = () => {
    apiRequest({
      url: `${link}api/cs/get/quick/report/`,
      token: accessToken,
      setLoading: setGetQuickLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setQuickReport(data);
      }
    });
  }
  const [getAdLoad, setGetAdLoad] = useState(false);
  const [bannerOrder, setBannerOrder] = useState({});
  const [bannerList, setBannerList] = useState();
  useEffect(() => {
    setBannerOrder(prev => ({}));
    if (bannerList !== undefined) {
      Object.keys(bannerList).map(item => {
        setBannerOrder(prev => ({
          ...prev, [item.substring(1)]: parseInt(bannerList[item].priority)
        }));
      });
    }
  }, [bannerList]);
  const getBanner = () => {
    apiRequest({
      url: `${link}api/cs/get/ads/`,
      token: accessToken,
      setLoading: setGetAdLoad,
      setAccessToken: setAccessToken,
      onSuccess: (data) => {
        setBannerList(data);
      }
    });
  }
  return (
    <AppContext.Provider value={{
      accessToken, link, setPage, page, setAccessToken, user, setUser, getExpired, setExpired, agents, setAgents, getLoad, setGetLoad,
      getExpiredLoad, setGetExpiredLoad, expired, getStaffs, staff, setStaff, getStaffLoad, getQuickLinksLoad, getQuickLinks,
      quickLinks, setQuickLinks, quickReport, getQuickLoad, getQuickReport, getAdLoad, bannerList, setBannerList, getBanner,
      allAccounts, setAllAccounts, bannerOrder, setBannerOrder, getAccountLoad, setGetAccountLoad, getAgents, packages, setPackages,
      getPackages, recentRenew, setRecentRenew, getRecentRenew, invoice, setInvoice, invoiceModal, setInvoiceModal, enquiries, getEnquiries,
      leadStatues, getLeadStatuses
    }} >
      {
        accessToken === undefined ? (
          <Authentication />
        ) : (
          <Dashboard />
        )
      }
    </AppContext.Provider>
  );
}

export default App;
